<template>
<div class="chapter">
<div class="inner_page">
<p class="chap-title"><span>BLUE YODEL 3</span></p>
<p class="chap-subtitle1"><span>THREE YOUTHS</span></p>
<p class="indent">Three youths on subway. <span class="smallcaps"><i>FIRST YOUTH</i>,</span> the shortest, says a girl has told him she wants him to leave her alone. He is inclined to leave her alone.</p>
<p class="indent"><span class="smallcaps"><i>SECOND YOUTH</i></span>: <i>Naw. That’s what she</i> want <i>you to do</i>.</p>
<p class="indent"><span class="smallcaps"><i>THIRD YOUTH</i></span>: <i>Can’t do that</i>.</p>
<p class="indent"><span class="smallcaps"><i>SECOND YOUTH</i></span>: <i>You do, she be the first one talking shit on you. “He a fag, I tole him to leave me alone; he leave me</i> alone.”</p>
<p class="indent"><span class="smallcaps"><i>THIRD YOUTH</i></span>: <i>You can act like you leavin’ her alone. But don’t</i> do <i>it</i>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter05.vue?1b670e05